import { Checkbox } from "@/components/ui/checkbox";

export const PERM_MODULES = [
  ["dashboard", "Dashboard"],
  ["members", "Members"],
  ["families", "Families"],
  ["birthdays", "Birthdays"],
  ["events", "Events"],
  ["announcements", "Announcements"],
  ["content", "Church Content"],
  ["ledger", "Ledger (view & categories)"],
  ["income", "Income Entries"],
  ["expenses", "Expense Entries"],
  ["reports", "Reports & Exports"],
  ["messages", "Contact Messages"],
  ["settings", "Website Settings"],
];

const PERM_ACTIONS = [
  ["view", "View"],
  ["create", "Create"],
  ["edit", "Edit"],
  ["delete", "Delete"],
];

export function emptyMatrix() {
  return Object.fromEntries(
    PERM_MODULES.map(([m]) => [m, { view: false, create: false, edit: false, delete: false }])
  );
}

export default function PermissionMatrix({ value, onChange, idPrefix = "perm" }) {
  const perms = value || emptyMatrix();
  const toggle = (m, a) =>
    onChange({ ...perms, [m]: { ...(perms[m] || {}), [a]: !perms[m]?.[a] } });
  return (
    <div className="overflow-x-auto rounded-md border border-border" data-testid={`${idPrefix}-matrix`}>
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-border bg-secondary/60 text-left">
            <th className="px-3 py-2 font-medium">Module</th>
            {PERM_ACTIONS.map(([a, label]) => (
              <th key={a} className="px-3 py-2 text-center font-medium">{label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {PERM_MODULES.map(([m, label]) => (
            <tr key={m} className="border-b border-border/60 last:border-0">
              <td className="px-3 py-2 text-foreground/90">{label}</td>
              {PERM_ACTIONS.map(([a]) => (
                <td key={a} className="px-3 py-2 text-center">
                  <Checkbox
                    checked={Boolean(perms[m]?.[a])}
                    onCheckedChange={() => toggle(m, a)}
                    data-testid={`${idPrefix}-${m}-${a}`}
                    aria-label={`${label} ${a}`}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
